import React from 'react';
import { Routes, Route } from 'react-router-dom';
import StandardAppLayout from 'src/shared/components/layout/standard-app-layout/StandardAppLayout';
import useCustomer from 'src/app/customers/hooks/useCustomer';
import useAuthService from 'src/shared/hooks/useAuthService';
import OrganisationLozenge from 'src/app/admin/components/organisation-lozenge/OrganisationLozenge';
import SiteDetail from './views/site-detail/SiteDetail';
import SiteManifestPreview from './views/site-manifest-preview/SiteManifestPreview';
import RiskPortfolioAdmin from './RiskPortfolioAdmin';
import styles from './RiskPortfolioAdmin.module.scss';

const RiskPortfolio = () => {
    const { currentCustomerId, currentCustomerName, currentCustomerProjects } = useCustomer();
    const { isCurrentUserSuperAdmin } = useAuthService();

    const projects = (currentCustomerProjects || []).map(p => ({
        projectId: p.projectId,
        projectName: p.projectName,
    }));

    const customerDetails =
        isCurrentUserSuperAdmin && currentCustomerName ? (
            <OrganisationLozenge customerId={currentCustomerId} customerName={currentCustomerName} />
        ) : null;

    return (
        <StandardAppLayout
            classNames={{ mainContent: styles.mainContent }}
            mainContent={
                <Routes>
                    <Route path='sites/:siteId' element={<SiteDetail currentCustomerId={currentCustomerId} />} />
                    <Route path='manifest-preview' element={<SiteManifestPreview currentCustomerId={currentCustomerId} />} />
                    <Route
                        path='*'
                        element={
                            <RiskPortfolioAdmin
                                currentCustomerId={currentCustomerId}
                                currentCustomerName={currentCustomerName}
                                projects={projects}
                            />
                        }
                    />
                </Routes>
            }
            title='Global Nature Risk Management'
            subTitle='Add sites to GNR and manage their geographies and activities'
            lozenges={customerDetails}
        />
    );
};

export default RiskPortfolio;
